import { useTranslation } from 'react-i18next';

import { useUiSettings } from '../../features/config/core/UiSettingsContext';

/*
 * Topbar switch between the two useful content widths: the default
 * readable one (tables stop at 60rem, plain pages are a centred
 * column) and the whole window width, which the wide tables of the
 * office areas benefit from. The choice is remembered per browser (see
 * UiSettingsContext); the icon shows what the click will do, arrows
 * pointing outwards to widen, inwards to go back.
 */
export function WidthToggle() {
  const { t } = useTranslation();
  const { wideLayout, setWideLayout } = useUiSettings();

  const label = wideLayout ? t('topbar.width.limit') : t('topbar.width.expand');

  return (
    <button
      className={`width-toggle${wideLayout ? ' is-wide' : ''}`}
      title={label}
      aria-label={label}
      aria-pressed={wideLayout}
      onClick={() => setWideLayout(!wideLayout)}
    />
  );
}
